import React, { useEffect, useState } from 'react';
import { ScrollText, ExternalLink } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { fmtDate } from '../../lib/dates';

// Latest norms published (BCN) — checked every 15 minutes and fed to Cerebro, CRM and the agents
export const NormWatchPanel = () => {
  const { api } = useAuth();
  const [d, setD] = useState(null);
  useEffect(() => { api.get('/norm-watch/latest').then((r) => setD(r.data)).catch(() => {}); }, [api]);
  if (!d?.norms?.length) return null;
  return (
    <div data-testid="norm-watch-panel" className="mb-8 rounded-xl border border-slate-800 bg-slate-900/60 p-4">
      <div className="flex flex-wrap items-center gap-2">
        <p className="flex items-center gap-2 text-sm font-semibold text-white"><ScrollText className="h-4 w-4 text-emerald-400" />Normativa recién publicada</p>
        <span data-testid="norm-watch-last-run" className="text-[11px] text-slate-500">Revisado {d.last_run ? fmtDate(d.last_run.at, true) : '—'} · cada 15 min · Cerebro y los agentes ya la consideran</span>
      </div>
      <ul className="mt-3 space-y-1.5">
        {d.norms.slice(0, 5).map((n) => (
          <li key={n.id_norma} className="flex items-start gap-2 text-xs">
            <span className="shrink-0 text-slate-500">{fmtDate(n.fecha_publicacion)}</span>
            <a href={n.link} target="_blank" rel="noreferrer" className="min-w-0 flex-1 text-slate-200 hover:text-amber-300"><span className="font-semibold">{n.tipo} {n.numero}</span> · {n.titulo.toLowerCase()} <ExternalLink className="inline h-3 w-3" /></a>
          </li>
        ))}
      </ul>
    </div>
  );
};
